<template>
  <p
    v-if="item.error"
    class="error"
  >
    {{ item.error }}
  </p>
</template>


<script>
export default {
  name: 'ErrorMessage',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.error {
  color: #ff0a0a;
  margin-top: 10px;
}
</style>